

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getUsers, UserListResponse } from "../../../../api/user";

interface UseUserListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
}

export const useUserList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
}: UseUserListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit] = useState(initialLimit);

  const responseQuery = useQuery<UserListResponse>({
    queryKey: ["admin-users", { page, limit }],
    queryFn: () => getUsers({ page, limit }, isAdmin),
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
  };

  return {
    ...responseQuery,
    page,
    limit,
    onPaginationChange,
  };
};